import React, { ReactNode } from "react";

import { useIntl } from "react-intl";

import styles from "./NoTerritories.module.scss";

interface Props {
  description?: ReactNode;
  icon: string;
}

const NoTerritories: React.FC<Props> = ({ description, icon }) => {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <img alt="no territories icon" className={styles.icon} src={icon} />
      <div className={styles.title}>
        {intl.formatMessage({
          id: "map.territories.noTerritories",
          defaultMessage: "No Territories Yet",
          description: "No territories state's title territories popover on the Map page",
        })}
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default NoTerritories;
